// src/pages/Mafia/mafiaPrintHeading.js
//
// The words on the heading of the MAFIA printouts (MAFIA Table, Digital
// Inspection Record), as the engineers asked for them (2026-09-29):
//   - the name of the document is the title, not the company and its address;
//   - the part number is named "S.S. White Part Number";
//   - "Part Revision" is the revision of the drawing, two digits like on the
//     drawing (1 is printed 01); the MAFIA revision is named next to it.
// The company chosen under "Document Branding" names the part number.

const PART_NUMBER_LABELS = {
  sswhite: "S.S. White Part Number",
  shukla: "Shukla Medical Part Number",
  sss: "Shukla Surgical Support Part Number",
};

export const MAFIA_TABLE_TITLE = "MAFIA Table";
export const DIR_TITLE = "Digital Inspection Record";

/** "S.S. White Part Number" for the chosen branding (unknown = S.S. White). */
export function partNumberLabel(branding) {
  return PART_NUMBER_LABELS[branding] || PART_NUMBER_LABELS.sswhite;
}

/** The revision of the drawing the way the drawing shows it: 1 -> "01", 12 -> "12". Anything else stays as it is. */
export function partRevisionText(rev) {
  if (rev == null) return "";
  const text = String(rev).trim();
  return /^\d$/.test(text) ? `0${text}` : text;
}

/** "Part Revision: 01    MAFIA Revision: 3" */
export function revisionLine(rev, revMinor, gap = "    ") {
  return `Part Revision: ${partRevisionText(rev)}${gap}MAFIA Revision: ${revMinor == null ? "" : String(revMinor).trim()}`;
}
